module.exports = __webpack_public_path__ + "img/plan-b-off.ef87b5e1.png";